// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__16mhC","alertIcon":"ConfirmModal_alertIcon__MyHz6"};